import React from 'react';

import { useSelector } from 'react-redux';

import { actions } from 'coupon-common/src/modules/referrals/customers';

import CommonList from './CommonList';

const CustomersReferrals = () => {
  const customers = useSelector(state => state.referrals.customers);

  return <CommonList getListAction={actions.getCustomersList} stateEntity={customers} />;
};

export default CustomersReferrals;